import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getUserPointHistory} from '../../../apis/point/getUserPointHistory'

const useQueryGetUserPointHistory = (id: string) => {
    const {data, refetch} = useQuery({
        enabled: !!id,
        queryKey: QueryCacheKeys.point.getUserPointHistory(id),
        queryFn: async () => {
            const {data, pageInfo} = await getUserPointHistory(id)
            return {data, pageInfo}
        },
    })

    return {data: data?.data, pageInfo: data?.pageInfo, refetch}
}

export default useQueryGetUserPointHistory
